export const REDIS_KEYS = {
	apyReturnsV2: 'apy_returns_v2',
};
